import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Snapshot_Type_Search_Fields: { [id: string]: ISearchProviderField } = {

    WB_SNAPSHOTM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Snapshot Type Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SNAPSHOT_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Snapshot Type Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    SNAPSHOT_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Snapshot Type Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const SnapshotTypeSearchProviderBasic: ISearchProvider =
    {
        keyFields: {
            id: 'WB_SNAPSHOTM_ID',
            id_ui: 'SNAPSHOT_TYPE_ID',
            name: 'SNAPSHOT_TYPE_NAME'
        },

        searchProviderFields: vUI_Snapshot_Type_Search_Fields,


        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {
                let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    searchOptions.where['WB_COMPANY_ID'] = {inq: _.map(usrContext.WB_Companies, 'WB_COMPANY_ID')}
                }

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Snapshot_Type_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err) => {
                        error(err)
                    })
            })
        },

        distinctValues(fieldName: string): Promise<string[] | number[]> {
            return new Promise<string[] | number[]>((resolve, error) => {
                let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                let searchOptions: { where?: { [id: string]: any } } = {}
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    searchOptions = {
                        where: {['WB_COMPANY_ID']: {inq: _.map(usrContext.WB_Companies, 'WB_COMPANY_ID')}}}
                    }
                    let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                        'vUI_Snapshot_Type_Search',
                        this.searchProviderFields,
                        [fieldName])

                    PASearch.findByRequest(findRequest)
                        .then((res: any[]) => {
                            resolve(_.map(res, (aRow) => {
                                return aRow[fieldName]
                            }))
                        })
                        .catch((err) => {
                            error(err)
                        })
                }
            )
            }
        }


        const SnapshotTypeSearchProfileByName
:
ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "SnapshotTypeSearchProfileByName"},


    profileFilter: [
        {profileFilterName: 'Snapshot Type Id', searchProviderFieldId: 'SNAPSHOT_TYPE_ID', renderOptions: {}},
        {profileFilterName: 'Snapshot Type Name', searchProviderFieldId: 'SNAPSHOT_TYPE_NAME', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'SNAPSHOT_TYPE_ID', 'SNAPSHOT_TYPE_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SnapshotTypeSearchProviderBasic,

    profileTreeIdDefault: "BySnapshotType",
    profileTrees: [
        {
            treeId: "BySnapshotType",
            treeName: "By Snapshot Type ",
            nodeProviders: [new ColumnNodeProvider(['SNAPSHOT_TYPE_ID'], {defaultValues: "Empty Snapshot Type ID"})],
            renderOptions: {}
        },
        {
            treeId: "BySnapshotTypeName",
            treeName: "By Snapshot Type Name",
            nodeProviders: [new ColumnNodeProvider(['SNAPSHOT_TYPE_NAME'], {defaultValues: "Empty Snapshot Type Name"})],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const SnapshotTypeSearch: ISearch = {
    searchName: "Find Snapshot Type",
    renderOptions: {ui5ResourceId: "SnapshotTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SnapshotTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("SnapshotTypeBO", "SnapshotType", SnapshotTypeSearch, "Snapshot Type Search")

export {SnapshotTypeSearch}

